import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useEditionById } from "@/hooks/edition-by-id.hook";
import { useListEditionResources } from "@/hooks/list-edition-resources.hook";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { DocumentText } from "iconsax-react";
import { useAtomValue } from "jotai";
import RelevantDocumentsDropdownItem from "./relevant-documents-dropdown-item";

const RelevantDocumentsDropdown = () => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: edition } = useEditionById({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const { data: resources } = useListEditionResources({
    editionId: editionId,
    resourceLibraryId: edition?.libraryId || "",
    size: 100,
  });

  if (edition && edition.milestones.length) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="white" size="icon" className="[&_svg]:size-auto">
            <DocumentText size={24} />
          </Button>
        </PopoverTrigger>

        <PopoverContent side="bottom" align="end">
          <div className="flex gap-2">
            <DocumentText size={24} />
            <h4 className="font-bold text-[#4F5D6D]">Documentos de interés</h4>
          </div>

          <Separator className="my-4" />

          <div className="-mx-2 flex max-h-96 flex-col overflow-y-auto">
            {resources?.content.length === 0 && (
              <div className="my-4 text-sm text-muted-foreground">
                Aún no se ha publicado ningún documento para la edición.
              </div>
            )}

            {resources?.content.map((resource) => (
              <RelevantDocumentsDropdownItem
                key={resource.id}
                resourceLibraryId={edition?.libraryId || ""}
                resource={resource}
              />
            ))}
          </div>
        </PopoverContent>
      </Popover>
    );
  }
};

export default RelevantDocumentsDropdown;
